import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';
const GraphsSlice = createSlice({
    name: 'graph',
    initialState: {
        getGraphByUserId: {},
        getTemplates: {},
        getAllChartsAvailable: {},
        getChartsAvailableByDashboardId: {},
        addCharts: {},
        updateDashboardName: {},
        updateChartPositions: {},
        deleteItemChart: {},
        createDashboard: {},
    },
    reducers: {},

    extraReducers: {
        'graph/getGraphByUserId/fulfilled': (state, action) => {
            state.getGraphByUserId = ResponseApi(action.payload);
        },
        'graph/getTemplates/fulfilled': (state, action) => {
            state.getTemplates = ResponseApi(action.payload);
        },
        'graph/getAllChartsAvailable/fulfilled': (state, action) => {
            state.getAllChartsAvailable = ResponseApi(action.payload);
        },
        'graph/getChartsAvailableByDashboardId/fulfilled': (state, action) => {
            state.getChartsAvailableByDashboardId = ResponseApi(action.payload);
        },
        'graph/addCharts/fulfilled': (state, action) => {
            state.addCharts = ResponseApi(action.payload);
        },
        'graph/updateDashboardName/fulfilled': (state, action) => {
            state.updateDashboardName = ResponseApi(action.payload);
        },
        'graph/updateChartPositions/fulfilled': (state, action) => {
            state.updateChartPositions = ResponseApi(action.payload);
        },
        'graph/deleteItemChart/fulfilled': (state, action) => {
            state.deleteItemChart = ResponseApi(action.payload);
        },
        'graph/createDashboard/fulfilled': (state, action) => {
            state.createDashboard = ResponseApi(action.payload);
        },
    },
});

export const {} = GraphsSlice.actions;

export default GraphsSlice.reducer;
